import { useMemo } from 'react';
import Image from 'next/image';

import { useGetUserInsuranceByDoctorId } from '@api/profile/index.rq';
import NextImage from '@com/_core/NextImage';
import useModal from '@hooks/useModal';

import SupportedInsurancesBottomSheet from '@com/shared/SupportedInsurancesBottomSheet';

type DoctorInfoInsurancesProps = {
  doctorId: number;
};

const DoctorInfoInsurances = ({ doctorId }: DoctorInfoInsurancesProps) => {
  const { addModal } = useModal();

  const SUPPORTED_INSURANCE_PREVIEW_COUNT = 3;

  const { data: insurancesData } = useGetUserInsuranceByDoctorId(
    {
      id: doctorId,
      pageNumber: 1,
      pageSize: 100,
    },
    {
      enabled: !!doctorId,
    },
  );

  const insurances = useMemo(
    () =>
      (insurancesData?.queryResult ?? [])
        .filter((item) => item.isActive)
        .map((item) => ({
          id: item.insuranceId,
          name: item.insuranceName,
          insuranceTypeId: item.insuranceTypeId,
          insuranceTypeName: item.insuranceTypeName,
          logoUrl: item.imageUrl,
        })),
    [insurancesData?.queryResult],
  );

  const previewInsurances = insurances.slice(
    0,
    SUPPORTED_INSURANCE_PREVIEW_COUNT,
  );

  const handleOpenInsurancesBottomSheet = () => {
    addModal({
      modal: SupportedInsurancesBottomSheet,
      props: {
        insurances,
      },
    });
  };

  if (!insurances.length) return null;

  return (
    <div className="flex items-center justify-between gap-x-2 pt-2">
      <div className="text-Body/xSmall text-content-primary">
        بیمه‌های تحت‌پوشش
      </div>

      <div className="flex items-center">
        <div className="flex items-center -space-x-2 rtl:space-x-reverse">
          {previewInsurances.map((insurance, index) => (
            <div
              key={insurance.id}
              style={{ zIndex: previewInsurances.length - index }}
              className="relative flex h-6 w-6 items-center justify-center overflow-hidden rounded-full border border-border-primary bg-surface-primary"
            >
              {insurance.logoUrl ? (
                <NextImage
                  src={insurance.logoUrl}
                  alt={insurance.name}
                  width={24}
                  height={24}
                />
              ) : (
                <Image
                  src="/images/emptyImage.png"
                  alt="insurance placeholder image"
                  width={24}
                  height={24}
                />
              )}
            </div>
          ))}
        </div>

        <button
          type="button"
          onClick={handleOpenInsurancesBottomSheet}
          className="text-Body/xSmall px-2 py-0.5 rounded-full bg-surface-disable text-content-tertiary mr-0.5"
        >
          مشاهده
        </button>
      </div>
    </div>
  );
};

export default DoctorInfoInsurances;
